import React from 'react';

export default function PaytrIframe({ token }) {
  // token, backend'den alınan iframe html kodu veya url olmalı
  if (!token) return null;
  return (
    <iframe
      title="PayTR Payment"
      src={`https://www.paytr.com/odeme/guvenli/${token}`}
      frameBorder="0"
      width="100%"
      height="500"
      style={{ border: 'none' }}
      allowFullScreen
    />
  );
}
